"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadingConfig = void 0;
/**
 * Class dùng tạo các object cấu hình để đọc số.
 * Các cấu hình mặc định như bên dưới.
 * Có thể thay đổi tùy theo nhu cầu sử dụng.
 */
class ReadingConfig {
    constructor() {
        this.separator = ' ';
        this.unit = ['đơn', 'vị'];
        this.negativeSign = '-';
        this.pointSign = '.';
        this.periodSize = 3;
        this.filledDigit = '0';
        this.digits = [
            'không', 'một', 'hai', 'ba', 'bốn',
            'năm', 'sáu', 'bảy', 'tám', 'chín'
        ];
        this.units = [
            [], ['nghìn'], ['triệu'], ['tỉ'],
            ['nghìn', 'tỉ'], ['triệu', 'tỉ'], ['tỉ', 'tỉ']
        ];
        this.negativeText = 'âm';
        this.pointText = 'chấm';
        this.oddText = 'lẻ';
        this.tenText = 'mười';
        this.hundredText = 'trăm';
        this.oneToneText = 'mốt';
        this.fourToneText = 'tư';
        this.fiveToneText = 'lăm';
        this.tenToneText = 'mươi';
    }
}
exports.ReadingConfig = ReadingConfig;
//# sourceMappingURL=ReadingConfig.js.map